import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import { Form } from 'react-bootstrap'

/**
 * @param {{
 *    id: string
 *    name: string
 *    className?: string
 *    disabled?: boolean
 *    onChange?: any
 * }} props
 * @returns {React.Component}
 */
const ZariInputFile = ({ className, ...props }) => {
  return (
    <Form.Control
      {...props}
      className={clsx('zr-form__control zr-form__input-file', className)}
      type='file'
      size='sm'
    />
  )
}

ZariInputFile.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func
}

export default ZariInputFile
